module.exports = __webpack_public_path__ + "static/media/6n.7387f7e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/6n.svg
// module id = 155
// module chunks = 0